export default "__VITE_ASSET__55b22aee__"